/*globals appendQueryParam, addQueryParam */
(function () {
	'use strict';

	angular.module('app.supplyChain')
		.service('inventoryBurnoffService', inventoryBurnoffService);

	inventoryBurnoffService.$inject = ['$rootScope', '$http', '$q', '$location', '$filter',
		'URLS', 'leanFilterService', 'excelExportService', '$experiments', 'storeService', 'tableService'];

	function inventoryBurnoffService($rootScope, $http, $q, $location, $filter,
			URLS, leanFilterService, excelExportService, $experiments, storeService, tableService) {
		return {
			getChartData: getChartData,
			getHistory: getHistory,
			getFiscalQuarters: getFiscalQuarters,
			buildUrlWithoutParams: buildUrlWithoutParams,
			startDrawerExcel: startDrawerExcel,
			getQueryParamList: getQueryParamList,
			relDate: relDate,
			relMonthlyDate: relMonthlyDate
		};

		function addFilterQueryParams(url, params) {
			var parts = url.split('?');
			var qParams = '';
			if (parts.length > 1) {
				qParams = '?' + parts[1];
			}

			for (var i = 0; i < params.length; i++) {
				qParams = appendQueryParam(qParams, params[i].key, params[i].value);
			}

			return parts[0] + qParams;
		}

		function getQueryParamList(leaveDecoded) {
			var qParams = leanFilterService.getQueryParam(leaveDecoded) || [];

			var options = storeService.getState().reportSettings.config.options;
			var apiOption = ['weeklyOrMonthly', 'pastDueVersion', 'includeUnactionablePOs', 'includeExcludedItems'];
			if (options) {
				for (var keyIndex in apiOption) {
					var keyValue = apiOption[keyIndex];
					if (options[keyValue]) {
						qParams.push({ key: keyValue, value: options[keyValue] });
					}
				}
			}
			return qParams;
		}

		function getFiscalQuarters() {
			var factories = leanFilterService.getFactoryList();
			var formattedDate = $filter('date')(new Date(), 'yyyy-MM-dd');
			var url = URLS.host + URLS.prefix + factories + '/Calendar/FiscalQuarters/FromDate/' + formattedDate + '/NumberOfQuarters/4';
			return $http.get(url).then(function (response) {
				return response.data;
			});
		}

		function buildUrlWithoutParams(date, isDrawer) {
			var factories = leanFilterService.getFactoryList();
			var url = URLS.host + URLS.prefix + factories + (isDrawer ? '/InventoryOptimizationDetails' : '/InventoryBurnoff');
			if (date) {
				url += 'History/Date/' + date;
			}
			return url;
		}

		function buildUrl(date, isDrawer) {
			var url = buildUrlWithoutParams(date, isDrawer);
			url = addFilterQueryParams(url, getQueryParamList());

			return url;
		}

		function getChartData() {
			var projectedDataUrl = buildUrl();
			var factories = leanFilterService.getFactoryList();
			var pastDataUrl = URLS.host + URLS.prefix + factories + '/WeeklyLogItem?includeTarget=true&daysBack=-180';
			var itemTypes = leanFilterService.getList('itemType');
			var includePurchased = true;
			var includeManufactured = true;
			for (var i in itemTypes) {
				if (itemTypes[i].itemType == 'Purchased') {
					includePurchased = itemTypes[i].selected;
				} else {
					includeManufactured = itemTypes[i].selected;
				}
			}
			var includeBoth = includePurchased && includeManufactured || !includePurchased && !includeManufactured;
			if (includePurchased || includeBoth) {
				pastDataUrl += '&purchasedFields=totalOnHandValue,pastDuePOValue,pastDueRequirementValue';
			}
			if (includeManufactured || includeBoth) {
				pastDataUrl += '&manufacturedFields=totalOnHandValue,pastDuePOValue,pastDueRequirementValue';
			}
			pastDataUrl = addFilterQueryParams(pastDataUrl, getQueryParamList());

			var projectedPromise = $http.get(projectedDataUrl);
			var pastPromise = $http.get(pastDataUrl);

			return $q.all([projectedPromise, pastPromise]).then(function (result) {
				var tmp = [];
				angular.forEach(result, function (response) {
					if (response.status !== 200) {
						tmp.push({});
					} else {
						tmp.push(response.data);
					}
				});
				if (includeManufactured || includeBoth) {
					angular.forEach(tmp[1].data, function (pastData) {
						if (includePurchased || includeBoth) {
							pastData.totalOnHandValue += pastData.totalOnHandValueManufactured;
							pastData.pastDueRequirementValue += pastData.pastDueRequirementValueManufactured;
							pastData.pastDuePOValue += pastData.pastDuePOValueManufactured;
						} else {
							pastData.totalOnHandValue = pastData.totalOnHandValueManufactured;
							pastData.pastDueRequirementValue = pastData.pastDueRequirementValueManufactured;
							pastData.pastDuePOValue = pastData.pastDuePOValueManufactured;
						}
					});
				}
				return tmp;
			});
		}

		function getHistory(date) {
			return $http.get(buildUrl(date))
				.then(getHistorySuccess, getHistoryFailure);
		}

		function getHistorySuccess(response) {
			return response;
		}

		function getHistoryFailure(error) {
			return error.statusText;
		}

		function relDate(weeks) {
			var d = new Date();
			d.setDate(d.getDate() + (7*weeks));
			return d;
		}

		function relMonthlyDate(months) {
			var d = new Date();
			d.setMonth(d.getMonth() + months);
			return new Date(d.getFullYear(), d.getMonth(), 0); // This sets to last day of month
		}

		function startDrawerExcel(periodNumber, weeklyOrMonthly, date, activeTab, sorters, fromDate) {
			var url = buildUrl(undefined, true);
			url = addFilterQueryParams(url, [
				{ key: 'drilldownPeriod', value: periodNumber },
				{ key: 'weeklyOrMonthly', value: weeklyOrMonthly },
				{ key: 'excelRequest', value: 'true' },
				{ key: 'activeTab', value: activeTab },
				{ key: 'fromDate', value: fromDate },
				{ key: 'drilldownDate', value: date.getTime() },
				{ key: 'sort', value: encodeURIComponent(JSON.stringify(sorters)) }
			]);

			var tabToFileName = {
				'net-opportunity': 'NetOpportunity',
				'reduction-results': 'ReductionResults',
				'lost-opportunity': 'LostOpportunity'
			};

			var customFileName = tabToFileName[activeTab] + '_' + $filter('date')(date, 'mediumDate', 'UTC').replace(/ /, '').replace(/,/g, '-') + '_Exported';
			excelExportService.getExcelReportWithGet(leanFilterService.getFactoryList(), url, $rootScope.$new(), undefined, undefined, customFileName);
		}
	}
})();
